<section class="input-template-container">
  <section class="input-template-container">
    <div class="action-buttons-container">
      <!-- Warning Message -->
      <!-- INFO: Functionality not applicable in PORTAL -->

      <!-- Back -->
      <button
        type="button"
        mat-stroked-button
        color="primary"
        (click)="onClickBack()"
      >
        <mat-icon>arrow_back</mat-icon> {{ "common.buttons.back" | translate }}
      </button>
    </div>

    <!-- Formly Form -->
    <form [formGroup]="form">
      <formly-form
        [fields]="fields"
        [form]="form"
        [model]="model"
        [options]="options"
      ></formly-form>
    </form>

    <!-- TEMP: Debug Component -->
    <app-debug-panel
      [form]="form.value"
      [levelNamesList]="levelsList"
      [model]="model"
      [options]="options"
      *ngIf="devMode.showDebugPanel"
    ></app-debug-panel>
  </section>
</section>
